
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import { routerNames, invoiceTitleType, invoiceType, wxAuthUrlConf } from '@/common/js/const';
import conf from './../../config/base.js';
import { setToken, getToken } from '@/common/js/common';
import regexpValid from '@/common/js/regexp.js';
import { cAddress } from '@/common/js/chinaAddress';
import feedback from '@/assets/feedback.svg'
import Policy from '@/views/personalCenter/policy.vue';
import Loading from 'vux/src/components/loading/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Radio from 'vux/src/components/radio/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellFormPreview from 'vux/src/components/cell-form-preview/index.vue'
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Search from 'vux/src/components/search/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Box from 'vux/src/components/box/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Toast from 'vux/src/components/toast/index.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'

export default {
name: routerNames.OrderInvoiceConfirm,
directives: {
TransferDom,
},
data() {
const policyChecked = localStorage.getItem('policyAgreeConfirmOut') === 'true';
return {
loading: true,
policyChecked: !policyChecked,
feedback,
cmsUrl:'',

searchGetResultTimer: null,
miAccount: '',
titleId: -1,
orderId: -1,
logoSrc: '',
amount: 0.0,
orderInfo: {
amount: '￥0.00',
list: [
{
label: this.$t('开票金额'),
value: '￥0.00',
},
{
label: this.$t('订单时间'),
value: '',
},
{
label: this.$t('订单号'),
value: '',
},
],
},

showInvoiceTitlePop: false,

invoiceTitles: [],
invoiceTitleType: invoiceTitleType,
titleType: invoiceTitleType.company, //默认公司
invoiceType: invoiceType,
wxAuthUrlConf: wxAuthUrlConf,
iType: invoiceType.dianZiPuTong, //默认电子发票
addressData: cAddress,
formInfoC: {
name: '',
taxerId: '',
bankName: '',
bankAccount: '',
companyAddr: '',
companyPhone: '',
isSpecialInvoice: invoiceTitleType.company, //isSpecialInvoice字段在数据库里用来标识抬头类型 1：企业 0：个人 2：非企业性单位
},
formInfoP: {
name: '个人',
nameNonBi: '', //非企业性单位需要和个人抬头字段分开
taxerId: '',
bankName: '',
bankAccount: '',
companyAddr: '',
companyPhone: '',
isSpecialInvoice: invoiceTitleType.person,
},
destination:'',//货物运输到达地
manualRemark:'',//备注
isTransport:false,//是否为货物运输类订单
contactAddr: [],
logisticsInfo: {
dContact: '',
dTel: '',
dProvince: '',
dCity: '',
dCounty: '',
dAddress: '',
logisticRemark: '',
},
userInfo: {
mobile: '',
email: '',
},
searchResults: [],
showSearch: false,
toastMsg: '',
isShowToast: false,
isWechat: true,
disableInvoice: false,
validTaxNumber4personOrNonbusiness(val){
if (regexpValid.taxNumber4personOrNonbusiness(val)) {
return { valid: true, msg: '' };
} else {
return { valid: false, msg: this.$t('税号有误') };
}
},

validTaxNumber(val) {
if (regexpValid.outInvoiceTaxNumber(val)) {
return { valid: true, msg: '' };
} else {
return { valid: false, msg: this.$t('税号有误，请输入15、18、20位数字、或数字+大写字母组成的税号') };
}
},

validInvoiceTitle(val) {
if (regexpValid.invoiceTitle(val)) {
return { valid: true, msg: '' };
} else {
return { valid: false, msg: this.$t('抬头长度小于100') };
}
},

validTel(val) {
if (regexpValid.mobile(val) || regexpValid.phone(val)) {
return { valid: true, msg: '' };
} else {
return { valid: false, msg: this.$t('电话有误') };
}
},
topHeight: '46px',
openId: '',
platform: '',
cpy: '',
merchant: '',
storeCode: '',
showEmail: true,
showUserTitle: true,

showTitles: false,

showTitlesIcon: true,

shareTitles: {
userTitles: this.$t('选择发票抬头'),

},
showPaperInvoice: false,
showSpecialElecInvoice: false,
emailRequired: true,
bankNameAccountPair: true,
};
},
created() {},
activated() {
var $self = this;
$self.$clog($self.$route.query);
$self.merchant = $self.$route.query.br;
$self.platform = $self.$route.query.pl ? $self.$route.query.pl : '';
$self.openId = $self.$route.query.openId ? $self.$route.query.openId : '';
$self.cpy = $self.$route.query.cpy;
$self.miAccount = $self.$route.query.mi;
const ut = $self.$route.query.ut;
$self.logoSrc = '/xforce/static/merch/' + $self.merchant + '/logo.jpg';
var params = { source: $self.merchant };
if ($self.platform == 'app') {
params.otId = $self.$route.query.us;
if ($self.merchant == 'capitaland' && params.otId == 'Capitaland') {
$self.showEmail = false;
}
$self.getUserToken(params);
} else if ($self.openId && $self.openId != '') {

if (____isAlipayBrowser()) {
params.otId = $self.openId;
} else if (____isWechatBrowser()) {
params.openId = $self.openId;
} else if (____isDingBrowser()) {
params.userId = $self.openId;
} else {
$self.showAlert(this.$t('请使用微信或支付宝开票'));
return;
}
$self.getUserToken(params);
} else if (ut && ut.length > 0) {
setToken(ut);
$self.initPage();
} else if (getToken()) {
$self.initPage();
}
},
watch: {
contactAddr(newVal, oldVal) {
console.log(newVal);
var $self = this;
try {
if (newVal.length == 3) {
$self.logisticsInfo.dProvince = $self.getName(newVal[0]);
$self.logisticsInfo.dCity = $self.getName(newVal[1]);
$self.logisticsInfo.dCounty = $self.getName(newVal[2]);
}
} catch (error) {
console.log(error);
}
},
titleType(newVal, oldVal) {
var $self = this;
if (newVal == '0' || newVal == '2' && oldVal == '0' || oldVal == '2') {
$self.formInfoP.taxerId = '';
}
}
},
/**计算属性 将状态表中的数据 映射出来*/
computed: {
isShowCitySelector(){
return  this.isTransport && this.merchant==='IKEA'
},
},
/**初始化的时候调用  类似于 ready */
mounted() {
bus.$on('changeDestination',(destination)=>{
this.destination = destination
});
},
methods: {

agreePolicyConfirm(){

localStorage.setItem('policyAgreeConfirmOut', "true");
this.policyChecked = false;
},
forbidBlank(e) {
e.target.value = e.target.value.replace(/\s+/g,'');
},
goSelectDestination(){
this.$router.push('citys');
},
...mapActions({
ACTION_setPageLoadingTrue: 'common_ac_setPageLoadingTrue',
}),
...mapActions({
ACTION_setPageLoadingFalse: 'common_ac_setPageLoadingFalse',
}),
initPage() {
var $self = this;
if (!____hasHeader) {
$self.topHeight = '0px';
} else {
$self.topHeight = '46px';
}
if (____isWechatBrowser()) {
$self.isWechat = true;

} else {
$self.isWechat = false;
}
$self.getUserTitleList();
$self.getCPYInfo();
if ($self.showEmail) {
$self.getUserEmail();
}
$self.getJsapiConfig();
$self.getPurchaserInfoConf();
},
getPurchaserInfoConf() {
let $self = this;
$self.$webapi.getPurchaserInfoConf($self.merchant).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
$self.emailRequired = res.data.result.emailEx === 1 ? true : false;
$self.bankNameAccountPair = res.data.result.bankInfoEx === 1 ? true : false;
}
});
},
getName(value) {
let ob = cAddress.find(element => element.value == value);
return typeof ob === 'undefined' ? '' : ob.name;
},
getAddrNameById(value) {
let name = '';
cAddress.forEach(item => {
if (item.id == value) {
name = item.name;
return name;
}
});
},
getTitles(e) {
e.stopPropagation()
this.showTitles = true;
},

shareTitlesClick(key, item) {
var $self = this;
if (key === 'userTitles') {
$self.clickUserTitles();
} else if (key === 'wechatTitles') {
$self.chooseWXInvoiceTitle();
}
},

clickUserTitles() {
this.showInvoiceTitlePop = true;
},

getUserEmail() {
var $self = this;
$self.$webapi.getUserEmail().then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
$self.userInfo.email = res.data.email;
}
});
},

getUserToken(params) {
var $self = this;
$self.$webapi.queryTokenByOtId(params).then(res => {
$self.$clog(res.data);
setToken(res.data.token);
$self.initPage();
});
},

getCPYInfo() {
var $self = this;
const params = {
data: $self.cpy,
groupFlag: $self.merchant,
type: '1',
};
$self.$webapi.hexEncryptOrDecrypt(params).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
var result = res.data.result;
var strs = result.split('&');
var obj = {};
strs.forEach(item => {
obj[item.split('=')[0]] = item.split('=')[1];
});

if ($self.merchant == 'IKEA' && (obj.st == '549' || obj.st == '247e' || obj.st == '819')) {
$self.showPaperInvoice = true;
}

if ($self.merchant == 'Walmart') {
$self.showSpecialElecInvoice = true;
}
$self.getOrderIdByUnicode(obj);
$self.storeCode = obj.st;
$self.getStoreInfo();
this.getCmsToken({dataMap:JSON.stringify({groupFlag: this.merchant,storeCode:obj.st})})
}
});
},
getCmsToken(params){
this.$webapi.getCmsToken(params).then(res => {
if(res.data.status==1){
this.cmsUrl = res.data.result
this.$store.dispatch('setCmsUrl',res.data.result)
}
})
},
getStoreInfo() {
var $self = this;
var params = {
groupFlag: $self.merchant,
storeCode: $self.storeCode,
};
$self.$webapi.getStoreConfig(params).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {
$self.logoSrc = '/xforce/static/merch/' + $self.merchant + '/' + res.data.result.logoPic + '.jpg';
}
});
},

getOrderIdByUnicode(obj) {
var $self = this;
let param = {
uniCode: obj.or,
amountWithTax: obj.am,
unAccount: 'wechat',
groupFlag: $self.merchant,
storeCode: obj.st,
onlyOrder: 1,
};

if ($self.merchant === 'RICHEMONT' || $self.merchant === "Richemont2019") {
param.ext = {
clientId: obj.cdb,
brand: obj.sub,
orderType: obj.ot,
};
param.uniCode = `${obj.or}-${obj.ot}`;
}
if ($self.merchant === 'Walmart') {
param.posDate = obj.da;
}
const unicode = {
dataMap: JSON.stringify(param),
};




$self.$webapi.queryOrderByUniCode(unicode).then(orderRes => {
$self.$clog(orderRes.data);
if (orderRes.data.status == 1) {
$self.orderId = orderRes.data.orderId;
$self.orderNo = orderRes.data.orderNo;
$self.amount = orderRes.data.amount;
$self.disableInvoice = false;
this.isTransport = orderRes.data.isTransport;
let list = [
{
label: this.$t('开票金额'),
value: "<span class='text-warning'>￥" + orderRes.data.amount + '</span>', //"￥" + orderRes.data.amount
},
{
label: this.$t('订单时间'),
value: orderRes.data.posDate,
},
{
label: this.$t('订单号'),
value: obj.or,
},
];
if (obj.st && obj.st !== 'null' && obj.st !== 'undefined') {
list.push({
label: this.$t('门店号'),
value: obj.st,
});
}
$self.orderInfo = {
amount: '￥' + orderRes.data.amount,
list: list,
};
$self.getInvoiceByOrderId($self.orderId, $self.orderNo);
} else if(orderRes.data.status == 302){
window.location.href = orderRes.data.redirectUrl
} else {
$self.orderId = -1;


$self.disableInvoice = true;
console.log(orderRes.data.msg);
console.log($self.disableInvoice);
$self.showAlert(orderRes.data.msg);
}
$self.loading = false;


});
},

getInvoiceByOrderId(orderId, orderNo) {
var $self = this;
$self.$webapi.getInvoiceByOrderId(orderId, orderNo, $self.merchant).then(orderRes => {
$self.$clog(orderRes.data);
if (orderRes.data.status == 1) {

if (orderRes.data.result instanceof Array && orderRes.data.result.length > 0) {
var buyerName = orderRes.data.result[0].buyerName;
var price = orderRes.data.result[0].price;
$self.$router.replace({
path: '/orderinvoice/state',
query: {
status: 1,
invoiceTypes: orderRes.data.result.map(function(item) {
return `${item.invoiceType}&${item.invoiceNo}_${item.invoiceCode}`
}).join(','),
ids: orderRes.data.result.map(function(item) {
return item.invoiceNo + "_" + item.invoiceCode;
}).join(','),
},
});
}
} else if (orderRes.data.status == 2) {

$self.$router.replace({
path: '/orderinvoice/state',
query: {
status: 2,
},
});
} else if (orderRes.data.status == 0) {

var buyerName = orderRes.data.result[0].buyerName;
var price = orderRes.data.result[0].price;
$self.$router.replace({
path: '/orderinvoice/state',
query: {
status: 0,
buyer: buyerName,
price: price,
},
});
} else {

$self.$webapi.invoiceMakeOverdue(orderId).then(res => {
$self.$clog(res.data);
if (res.data.status == 1) {

$self.$router.replace({
path: '/orderinvoice/state',
query: {
status: 3,
},
});
}
});
}
});
},
showAlert(msg) {
this.$vux.alert.show({
title: '',
content: msg,
onShow() {
console.log("Plugin: I'm showing");
},
onHide() {
console.log("Plugin: I'm hiding now");
},
});
},

getJsapiConfig() {
var $self = this;
$self.$webapi.getJsapiSign().then(res => {
$self.$clog(res.data);
window.wx.config({
beta: true,
debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
appId: res.data.appId, // 必填，公众号的唯一标识
timestamp: res.data.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
signature: res.data.signature, // 必填，签名，见附录1
jsApiList: [

'chooseInvoiceTitle',
],
});
});
},
getUserTitleList() {
var $self = this;
const params = {};
$self.$webapi.getUserTitleList(params).then(res => {
$self.$clog(res.data);
if (res.data instanceof Array && res.data.length > 0) {
res.data.forEach(item => {
item.key = item.id;
if (item.isDefault == '1') {
$self.titleId = item.id;
}
});
$self.invoiceTitles = res.data;
$self.shareTitles = {
userTitles: this.$t('选择发票抬头'),
};
if (____isWechatBrowser()) {
$self.shareTitles = {
userTitles: this.$t('选择发票抬头'),
wechatTitles: this.$t('使用微信抬头'),
};
}
const ua = window.navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == 'micromessenger') {
wx.miniProgram.getEnv((res) => {
if (res.miniprogram) {
this.shareTitles = {
userTitles: this.$t('选择发票抬头'),
};
} else {//在微信中
this.shareTitles = {
userTitles: this.$t('选择发票抬头'),
wechatTitles: this.$t('使用微信抬头'),
};
}
});
}
} else {
if (____isWechatBrowser()) {
$self.shareTitles = {
wechatTitles: this.$t('使用微信抬头'),
};
const ua = window.navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == 'micromessenger') {
wx.miniProgram.getEnv((res) => {
if (res.miniprogram) {
this.shareTitles = {};
}





});
}
} else {
$self.showTitlesIcon = false;
}
$self.showUserTitle = false;















}
});
},
getTitleNameFrom16(titleName) {
var $self = this;
$self.$webapi.getTitleNameFrom16(titleName).then(res => {
$self.$clog(res.data);
if (res.data instanceof Array) {
var result = res.data.map(item => {
return {
title: item.name,
other: item.id,
};
});

var some = result.some(item => {
return item.title === titleName;
});
$self.searchResults = some ? result : [{ title: titleName, other: 0 }, ...result];
}
});
},
chooseWXInvoiceTitle() {
var $self = this;
window.wx.ready(function() {
window.wx.invoke(
'chooseInvoiceTitle',
{
scene: '1',
},
function(res) {
var wxTitle = JSON.parse(res.choose_invoice_title_info);
var title = {
name: wxTitle.title,
taxerId: wxTitle.taxNumber,
bankName: wxTitle.bankName,
bankAccount: wxTitle.bankAccount,
companyAddr: wxTitle.companyAddress,
companyPhone: wxTitle.telephone,
};
if ($self.titleType == invoiceTitleType.company) {
$self.formInfoC = title;
} else if (
$self.titleType == invoiceTitleType.person ||
$self.titleType == invoiceTitleType.nonbusiness
) {
$self.formInfoP = title;
$self.formInfoP.nameNonBi = title.name;
}
}
);
});
},
showError(msg){
this.isShowToast = true;
this.toastMsg = this.$t(msg);
return;
},
async	nextStep() {
try {

var $self = this;
var titleIsValid = false;
var taxIdIsValid = true;

if ($self.titleType == invoiceTitleType.company) {
titleIsValid = this.$refs.input_invoice_title_name.valid;
taxIdIsValid = this.$refs.input_tax_number.valid;
} else if ($self.titleType == invoiceTitleType.person) {
titleIsValid = this.$refs.input_invoice_title_name1.valid;
} else if ($self.titleType == invoiceTitleType.nonbusiness) {
titleIsValid = this.$refs.input_invoice_title_name2.valid;
}
if (
!titleIsValid ||
!taxIdIsValid
) {
$self.isShowToast = true;
$self.toastMsg = this.$t('请准确填写抬头信息');
return;
}


if ($self.iType == invoiceType.zhuanYong) {
var bankValid = this.$refs.input_bank.valid;
var bankAccountValid = this.$refs.input_bankAccount.valid;
var telValid = this.$refs.input_tel.valid;
var companyAddrValid = $self.formInfoC.companyAddr.length > 0 ? true : false;

let info = $self.formInfoC;

if (!bankValid || !bankAccountValid || !telValid || !companyAddrValid || !info.bankAccount || !info.bankName || !info.companyPhone || !info.companyAddr) {

$self.isShowToast = true;
$self.toastMsg = this.$t('请准确填写抬头信息');
return;
}

var contactValid = this.$refs.input_contact.valid;
var contactTelValid = this.$refs.input_contact_tel.valid;
var contactAddrValid = $self.contactAddr.length === 3 ? true : false;
var contactDetailAddrValid = $self.logisticsInfo.dAddress.length > 0 ? true : false;
if (!contactValid || !contactTelValid || !contactAddrValid || !contactDetailAddrValid) {
$self.isShowToast = true;
$self.toastMsg = this.$t('请准确填写收件人信息');
return;
}
}

if ($self.iType == invoiceType.dianziZhuanYong) {
var bankValid = $self.formInfoC.bankName.length > 0 ? true : false;;
var bankAccountValid = $self.formInfoC.bankAccount.length > 0 ? true : false;;
var telValid = $self.formInfoC.companyPhone.length > 0 ? true : false;;
var companyAddrValid = $self.formInfoC.companyAddr.length > 0 ? true : false;
if (!bankValid || !bankAccountValid || !telValid || !companyAddrValid) {
$self.isShowToast = true;
$self.toastMsg = this.$t('请准确填写抬头信息');
return;
}
}

if ($self.bankNameAccountPair) {
let info = $self.titleType == invoiceTitleType.company ? $self.formInfoC : $self.formInfoP;
if ((!!info.bankName && !info.bankAccount) || (!info.bankName && !!info.bankAccount)) {
$self.isShowToast = true;
$self.toastMsg = this.$t('开户银行和银行账号必须同时填写');
return;
}
}
if(this.merchant==='IKEA'){
let info = $self.titleType == invoiceTitleType.company ? $self.formInfoC : $self.formInfoP;
if(this.iType==invoiceType.zhuanYong && info.companyAddr ===''){
this.showError('地址必填')
return
}
}
if(this.isTransport && this.destination.trim() === ''){
this.showError('货物运输类发票必须填到达地')
return
}
if ($self.orderId < 0) {
$self.showAlert(this.$t('获取订单信息失败'));
setTimeout(() => {
$self.$vux.alert.hide();
}, 3000);
return;
}
if ($self.orderId == 0) {
$self.showAlert(this.$t('小票已申请开票，请勿重复申请'));
setTimeout(() => {
$self.$vux.alert.hide();
}, 3000);
return;
}


















if(($self.iType == invoiceType.dianZiPuTong || $self.iType == invoiceType.dianziZhuanYong) && $self.emailRequired){
if(!this.$refs.input_email.valid ){
this.showError('请准确填写邮箱信息')
return
}

const {data:validateEmailResult}  = await this.$webapi.validateEmail(this.userInfo.email);
if(validateEmailResult.status === -1){//校验失败则提示是否确认用当前邮箱开票
this.$vux.confirm.show({
title:'邮箱存在异常可能无法接收发票，确认无误后点击开具按钮进行开票',
onCancel () {
return false
},
confirmText:'开具',
onConfirm:()=> {//确认开票则将校验失败的邮箱更新到白名单
this.prepareMakeoutInvoice(true)
}
});
}else{
this.prepareMakeoutInvoice(false)
}
return
}
this.prepareMakeoutInvoice(false)
} catch (error) {
this.isShowToast = true;
console.error(error)
this.toastMsg = error.toString();
}
},
async prepareMakeoutInvoice(needUpdateEmailWhiteList){
this.insertTitle().then(insertTitleResult=>{
this.updateUserEmail(needUpdateEmailWhiteList).then(updateUserEmailResult=>{
this.makeoutInvoice(insertTitleResult.id)
})
});
},
updateUserEmail(needUpdateEmailWhiteList){
return new Promise((resolve,reject)=>{
this.$webapi.updateUserEmail(this.userInfo.email,needUpdateEmailWhiteList).then(({data:updateUserEmailResult})=>{
this.$clog(updateUserEmailResult);
if (updateUserEmailResult.status == 1) {
resolve(updateUserEmailResult)
}else{
this.isShowToast = true;
this.toastMsg = updateUserEmailResult.msg;
reject(updateUserEmailResult)
}
})
});
},
insertTitle(){
return new Promise((resolve,reject)=>{
let params = {};
if (this.titleType == invoiceTitleType.company) {
this.formInfoC.isDefault = 1;
params = {
dataMap: JSON.stringify(this.formInfoC),
};
} else if (this.titleType == invoiceTitleType.person || this.titleType == invoiceTitleType.nonbusiness) {
if (this.titleType == invoiceTitleType.nonbusiness) {
this.formInfoP.isSpecialInvoice = invoiceTitleType.nonbusiness;
this.formInfoP.name = this.formInfoP.nameNonBi; 
} else {
this.formInfoP.isSpecialInvoice = invoiceTitleType.person;
}
this.formInfoP.isDefault = 1;
params = {
dataMap: JSON.stringify(this.formInfoP),
};
}
this.$webapi.insertTitle(params).then(res=>{
const insertTitleResult=res.data
this.$clog(insertTitleResult)
if(insertTitleResult.status==1){
resolve(insertTitleResult)
}else{
this.isShowToast = true;
this.toastMsg = insertTitleResult.msg;
reject(insertTitleResult)
}
});
})
},
async makeoutInvoice(insertTitleId){
try {
this.disableInvoice = true;
let invoiceJSON = {
order: this.orderId,
title: insertTitleId,
version: '3.0',
purchaserType: this.titleType == invoiceTitleType.person ? '2' : '1',
destination:this.destination,
manualRemark: this.manualRemark,
properties: {
miAccount: this.miAccount,
invoiceType: this.iType,
email: '',
cashierName: '',
checkerName: '',
invoicerName: '',
isAutoMakeOutInvoice: '1',
makeOutInvoiceMode: '1',
systemOrig: 'TOC',
},
};
invoiceJSON.logisticsInfo = this.logisticsInfo;
const invoiceParams = {
dataMap: JSON.stringify(invoiceJSON),
};
const {data:invoiceResult} =await this.$webapi.invoice(invoiceParams);
this.$clog(invoiceResult);
var tempId = this.orderId;
this.orderId = 0;
this.disableInvoice = false;
if (invoiceResult.status == 1) {
this.getWxAuthUrlConf(tempId);
} else {
this.showAlert(invoiceResult.msg);
}
} catch (error) {
this.isShowToast = true;
console.error(error)
this.toastMsg = error.toString();
}
},
getWxAuthUrlConf(tempId) {
var $self = this;

if (!____isWechatBrowser()) {
$self.$router.replace({
path: '/orderInvoice/success',
query: {
orderId: tempId,
br: $self.merchant,
orderNo: this.orderNo,
},
});
return;
}
$self.$webapi.getWxAuthUrlConf($self.merchant).then(res => {
$self.$clog(res.data);
if (res.data.status == 1 && res.data.result == $self.wxAuthUrlConf.beforeInvoice) {
var url = `${conf.api.SALES_API_ROOT}/issp/wechat/invoice/auth-url-v1.page?orderId=${tempId}&orderNo=${this.orderNo}&br=${
$self.merchant
}&money=${$self.amount}&apiKey=${getToken()}&redirectUrl=${conf.api.LOCATION_ORIGIN}/xforce/#/orderInvoice/success`;
window.location.replace(url);
} else {
$self.$router.replace({
path: '/orderInvoice/success',
query: {
orderId: tempId,
br: $self.merchant,
orderNo: this.orderNo,
},
});
}
});
},
chooseTitle() {
var $self = this;
$self.showInvoiceTitlePop = false;
$self.invoiceTitles.forEach(function(item) {
if (item.key === $self.titleId) {
console.log(item);
if ($self.titleType == invoiceTitleType.company) {
$self.formInfoC = item;
} else if (
$self.titleType == invoiceTitleType.person ||
$self.titleType == invoiceTitleType.nonbusiness
) {
$self.formInfoP = item;
$self.formInfoP.nameNonBi = item.name;
}
}
});
console.log($self.titleId);
},
setSearchFocus() {
var $self = this;
$self.showSearch = true;
this.$refs.input_invoice_title_name.blur();
this.$refs.search.setFocus();
},
searchResultClick(item) {
var $self = this;

$self.showSearch = false;

if (item.other < 1) {
this.formInfoC.name = item.title;
return;
}
$self.$webapi.getTitleInfoByIdFrom16(item.other).then(res => {
$self.$clog(res.data);
var title = {
name: res.data.name,
taxerId: res.data.taxNo,
bankName: res.data.bankName,
bankAccount: res.data.bankAccount,
companyAddr: res.data.address,
companyPhone: res.data.telephone,
};
$self.formInfoC = title;
});
},
searchGetResult(val) {
var $self = this;

clearTimeout(this.searchGetResultTimer)
this.searchGetResultTimer = setTimeout(function () {
$self.getTitleNameFrom16(val);
}, 500)

},
onSearchCancel() {
var $self = this;
$self.showSearch = false;
},
},

components: {
XHeader,
PopupHeader,
Popup,
Radio,
Group,
Cell,

CellFormPreview,
FormPreview,

XInput,
XTextarea,
Search,
XButton,
Box,
CheckIcon,
Checker,
CheckerItem,
Alert,
Actionsheet,
Toast,
XAddress,
Policy,
XDialog

},
};
